<template>
  <div
    :class="[
      `insert insert--${type ? type : 'no-type'}`,
      { 'is-accordion': accordion },
    ]"
  >
    <component
      :is="$slots.heading[0].tag"
      v-if="accordion"
      class="insert__heading"
    >
      <button
        :id="`accordion-toggle-${id}`"
        class="insert__toggle"
        :aria-expanded="isExpanded ? 'true' : 'false'"
        :aria-controls="`accordion-content-${id}`"
        @click="expand"
      >
        <span v-if="type" class="insert__icon">
          <bpb-icon :icon="iconKey" :decorative="true"></bpb-icon>
        </span>
        <u-render-vnodes :vnodes="$slots.heading[0].children"></u-render-vnodes>
        <span v-if="accordion && isExpanded" class="insert__icon-arrow">
          <bpb-icon icon="i-arrow-up--medium" :decorative="true"></bpb-icon>
        </span>
        <span v-else-if="accordion" class="insert__icon-arrow">
          <bpb-icon icon="i-arrow-bottom--medium" :decorative="true"></bpb-icon>
        </span>
      </button>
    </component>
    <component
      :is="$slots.heading[0].tag"
      v-else
      :id="`insert-heading-${id}`"
      class="insert__heading"
    >
      <span v-if="type" class="insert__icon">
        <bpb-icon :icon="iconKey" :decorative="true"></bpb-icon>
      </span>
      <u-render-vnodes :vnodes="$slots.heading[0].children"></u-render-vnodes>
      <span v-if="accordion && isExpanded" class="insert__icon-arrow">
        <bpb-icon icon="i-arrow-up--medium" :decorative="true"></bpb-icon>
      </span>
      <span v-else-if="accordion" class="insert__icon-arrow">
        <bpb-icon icon="i-arrow-bottom--medium" :decorative="true"></bpb-icon>
      </span>
    </component>
    <u-transition-height v-if="accordion">
      <section
        v-show="isExpanded"
        :id="`accordion-content-${id}`"
        :aria-labelledby="`accordion-toggle-${id}`"
        class="insert__content"
      >
        <slot name="content" />
      </section>
    </u-transition-height>
    <section
      v-else
      class="insert__content"
      :aria-labelledby="`insert-heading-${id}`"
    >
      <slot name="content" />
    </section>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      required: false,
    },
    accordion: {
      type: Boolean,
      reqired: false,
    },
    expanded: {
      type: Boolean,
      reqired: false,
    },
  },
  data() {
    return {
      id: this._uid,
      isExpanded: this.expanded || false,
    };
  },
  computed: {
    iconKey() {
      if (this.type === 'law') return 'i-paragraph';
      if (this.type === 'definition') return 'i-question-mark';
      if (this.type === 'source') return 'i-sources';
      return false;
    },
  },
  methods: {
    expand: function () {
      this.isExpanded = !this.isExpanded;
    },
  },
};
</script>
